import api from 'Application/api/api';

const getPlatformDomainName = (cancelToken = null) =>
    api.get('/platform-domain-name', { cancelToken });

export default getPlatformDomainName;
